export const Text = ({ children, className, as, ...rest }) => {
  const Component = as || 'span'
  return (
    <Component
      className={`text-base sm:text-lg font-light ${
        className || 'text-gray-50'
      }`}
      {...rest}
    >
      {children}
    </Component>
  )
}

export const Subtext = ({ children, className, as, ...rest }) => {
  const Component = as || 'span'
  return (
    <Component
      className={`text-sm sm:text-base font-light ${
        className || 'text-gray-50'
      }`}
      {...rest}
    >
      {children}
    </Component>
  )
}
